import { render, staticRenderFns } from "./PriceChangedAlert.vue?vue&type=template&id=907da7e2"
import script from "./PriceChangedAlert.vue?vue&type=script&lang=js"
export * from "./PriceChangedAlert.vue?vue&type=script&lang=js"
import style0 from "./PriceChangedAlert.vue?vue&type=style&index=0&id=907da7e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports